/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Restaurant } from '../model';
// @ts-ignore
import { Success } from '../model';
/**
 * RestaurantApi - axios parameter creator
 * @export
 */
export const RestaurantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Remove a restaurant
         * @param {string} id Id of the restaurant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restaurantDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restaurantDelete', 'id', id)
            const localVarPath = `/restaurant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or update a restaurant
         * @param {Restaurant} restaurant Details of the restaurant to add or update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restaurantPut: async (restaurant: Restaurant, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurant' is not null or undefined
            assertParamExists('restaurantPut', 'restaurant', restaurant)
            const localVarPath = `/restaurant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restaurant, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restaurants will be returned for the logged in (Cognito) user
         * @summary Get overview of all restaurants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restaurantsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/restaurants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestaurantApi - functional programming interface
 * @export
 */
export const RestaurantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestaurantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Remove a restaurant
         * @param {string} id Id of the restaurant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restaurantDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Success>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restaurantDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or update a restaurant
         * @param {Restaurant} restaurant Details of the restaurant to add or update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restaurantPut(restaurant: Restaurant, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Restaurant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restaurantPut(restaurant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Restaurants will be returned for the logged in (Cognito) user
         * @summary Get overview of all restaurants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restaurantsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Restaurant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restaurantsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RestaurantApi - factory interface
 * @export
 */
export const RestaurantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestaurantApiFp(configuration)
    return {
        /**
         * 
         * @summary Remove a restaurant
         * @param {string} id Id of the restaurant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restaurantDelete(id: string, options?: any): AxiosPromise<Success> {
            return localVarFp.restaurantDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or update a restaurant
         * @param {Restaurant} restaurant Details of the restaurant to add or update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restaurantPut(restaurant: Restaurant, options?: any): AxiosPromise<Restaurant> {
            return localVarFp.restaurantPut(restaurant, options).then((request) => request(axios, basePath));
        },
        /**
         * Restaurants will be returned for the logged in (Cognito) user
         * @summary Get overview of all restaurants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restaurantsGet(options?: any): AxiosPromise<Array<Restaurant>> {
            return localVarFp.restaurantsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestaurantApi - object-oriented interface
 * @export
 * @class RestaurantApi
 * @extends {BaseAPI}
 */
export class RestaurantApi extends BaseAPI {
    /**
     * 
     * @summary Remove a restaurant
     * @param {string} id Id of the restaurant to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestaurantApi
     */
    public restaurantDelete(id: string, options?: any) {
        return RestaurantApiFp(this.configuration).restaurantDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or update a restaurant
     * @param {Restaurant} restaurant Details of the restaurant to add or update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestaurantApi
     */
    public restaurantPut(restaurant: Restaurant, options?: any) {
        return RestaurantApiFp(this.configuration).restaurantPut(restaurant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restaurants will be returned for the logged in (Cognito) user
     * @summary Get overview of all restaurants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestaurantApi
     */
    public restaurantsGet(options?: any) {
        return RestaurantApiFp(this.configuration).restaurantsGet(options).then((request) => request(this.axios, this.basePath));
    }
}
